import { CIcon } from '~/icons/types'

export const ciDirtJumpBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M18.629 10.36a4.34 4.34 0 0 0-.98.12l-.977-2.741-.383-1.076-.087-.244h1.271a.627.627 0 0 0 .491-.365l.373-.818a.504.504 0 1 0-.917-.418l-.27.593h-1.663a.504.504 0 0 0-.475.673l.203.57-4.737 3.584-1.104-2.534.577.002h.001a.504.504 0 0 0 .002-1.008l-2.34-.008h-.002a.504.504 0 0 0-.001 1.008l.662.003 1.378 3.162-1.128.854a4.376 4.376 0 1 0 1.167 3.52h1.029a1.306 1.306 0 0 0 1.084.602 1.338 1.338 0 0 0 1.341-1.33 1.31 1.31 0 0 0-.094-.462l3.052-4.905.6 1.685a4.339 4.339 0 1 0 1.927-.468Zm-8.564 1.454.775 1.78a1.33 1.33 0 0 0-.311.635h-.838a4.317 4.317 0 0 0-.567-1.703Zm-1.75 1.324a3.314 3.314 0 0 1 .368 1.09h-1.81ZM5.37 18.092a3.363 3.363 0 1 1 2.345-5.765L5.067 14.33a.504.504 0 0 0 .304.906h3.311a3.358 3.358 0 0 1-3.31 2.855Zm6.967-4.809a1.318 1.318 0 0 0-.535-.115c-.016 0-.03.009-.045.01l-.866-1.99L15.57 7.65l.1.28Zm6.291 4.81a3.351 3.351 0 0 1-1.586-6.31l1.111 3.119a.505.505 0 0 0 .475.335.487.487 0 0 0 .17-.03.504.504 0 0 0 .305-.644l-1.116-3.131a3.361 3.361 0 1 1 .641 6.66Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'dirt-jump-bike',
  type: 'thin'
}
